import { useState, useCallback } from 'react';

export interface PopoverState {
  isPopoverOpen: boolean;
  anchorEl: HTMLElement | null;
  onPopoverOpen(
    event: React.MouseEvent<HTMLElement> | null,
    overrideElem?: HTMLElement | null
  ): void;
  onPopoverClose(): void;
}

export const usePopoverState = (): PopoverState => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return <PopoverState>{
    anchorEl,
    isPopoverOpen,
    onPopoverClose: useCallback(() => {
      setAnchorEl(null);
      setIsPopoverOpen(false);
    }, []),
    onPopoverOpen: useCallback(
      (
        event: React.MouseEvent<HTMLElement> | null,
        overrideElem?: HTMLElement | null
      ) => {
        const element =
          overrideElem || (event?.currentTarget ? event!.currentTarget : null);
        setAnchorEl(element);
        setIsPopoverOpen(true);
      },
      []
    )
  };
};
